







import { namespace } from 'vuex-class';
import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator';
import rest from "@/rest";
// components
import ExpandableCard from '../Shared/ExpandableCard.vue';
// interfaces
import { CourseElementVm } from '@/interfaces/CourseElementVm';
import { ParamDictionary } from '@/interfaces/ParamDictionary';
import { ExerciseVM } from '@/interfaces/ExerciseVM';
import CompSpeak from '../ExerciseComponents/CompSpeak.vue';

const globals = namespace("globals");

@Component({
    components: {
      ExpandableCard,
      CompSpeak
    }
  })
  export default class TtsReaderElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;

  // @Watch("selectedExercise")
  // async onSelectedExerciseChange() {
  // }

  }
  